import React from 'react';
import { GlassPage } from '../components/chrome';

const SECTIONS = [
  {
    title: '1. Acceptance of Terms',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        By accessing and using Korsa's website and services, you agree to be bound by these Terms of Service
        and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited
        from using or accessing this site.
      </p>
    )
  },
  {
    title: '2. Use License',
    body: (
      <>
        <p className="text-zinc-600 leading-relaxed">
          Permission is granted to temporarily access the materials on Korsa's website for personal,
          non-commercial transitory viewing only. This is the grant of a license, not a transfer of title,
          and under this license you may not:
        </p>
        <ul className="list-disc list-inside text-zinc-600 space-y-2 ml-4">
          <li>Modify or copy the materials</li>
          <li>Use the materials for any commercial purpose or public display</li>
          <li>Attempt to reverse engineer any software contained on Korsa's website</li>
          <li>Remove any copyright or proprietary notations from the materials</li>
        </ul>
      </>
    )
  },
  {
    title: '3. Product Information',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        Korsa smart glasses are assistive technology devices designed to enhance communication.
        We strive to provide accurate product information, but we do not warrant that product descriptions,
        specifications, or other content is accurate, complete, reliable, current, or error-free.
      </p>
    )
  },
  {
    title: '4. Privacy & Data',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        Your privacy is important to us. Our use of your personal information is governed by our Privacy Policy.
        By using our services, you consent to the collection and use of information as outlined in our Privacy Policy.
      </p>
    )
  },
  {
    title: '5. Pre-Orders',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        Pre-order availability, pricing, and delivery dates are subject to change. By placing a pre-order,
        you agree that Korsa may modify specifications or features before the final product release.
        We will notify you of any significant changes to your pre-order.
      </p>
    )
  },
  {
    title: '6. Software, Services & Subscriptions',
    body: (
      <>
        <p className="text-zinc-600 leading-relaxed">
          Korsa Glasses ship with KorsaOS. Some capabilities depend on services that cost us money to
          run continuously, including cloud processing, speech and language models, and third-party
          services. So that you know where you stand before you buy:
        </p>
        <ul className="list-disc list-inside text-zinc-600 space-y-2 ml-4">
          <li>
            The features described on the product page at the time of your purchase will remain
            available on your device without any recurring payment. We will not put a feature you
            already paid for behind a subscription.
          </li>
          <li>
            Korsa may introduce optional paid subscriptions for capabilities added after your
            purchase, including abilities offered through the marketplace, and for expanded use of
            services that carry an ongoing cost to operate.
          </li>
          <li>
            You will never be enrolled in a subscription automatically. If we introduce one that
            would affect you, we will give you at least 30 days notice by email, and declining it
            will not disable the features your device shipped with.
          </li>
          <li>
            If we ever cannot continue operating a service your device relies on, we will tell you in
            advance and describe what will keep working without it.
          </li>
        </ul>
      </>
    )
  },
  {
    title: '7. Limitations',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        Korsa or its suppliers will not be held liable for any damages arising out of the use or inability
        to use the materials on Korsa's website, even if Korsa or an authorized representative has been
        notified of the possibility of such damage.
      </p>
    )
  },
  {
    title: '8. Revisions',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        Korsa may revise these Terms of Service at any time. By using this website, you agree to be
        bound by the current version. Where a revision materially changes what you receive for a
        purchase you have already made, including the introduction of any charge described in
        section 6, we will notify you by email in advance rather than relying on your continued use
        of the site as agreement.
      </p>
    )
  },
  {
    title: '9. Governing Law',
    body: (
      <p className="text-zinc-600 leading-relaxed">
        These terms and conditions are governed by and construed in accordance with the laws of
        Massachusetts, United States, and you irrevocably submit to the exclusive jurisdiction of
        the courts in that location.
      </p>
    )
  },
  {
    title: '10. Contact Information',
    body: (
      <>
        <p className="text-zinc-600 leading-relaxed">
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p className="text-zinc-900 font-bold">
          support@korsa.tech
        </p>
      </>
    )
  }
];

const TermsOfService = () => {
  return (
    <GlassPage>
      {/* Hero Section */}
      <section className="relative flex flex-col justify-center px-6 md:px-12 pt-40 pb-12">
        <div className="max-w-4xl mx-auto w-full">
          <h1 className="text-[12vw] md:text-[6vw] font-bold leading-[0.9] tracking-tighter mb-8 uppercase text-zinc-900">
            Terms of<br/>Service
          </h1>
          <p className="text-sm text-zinc-500">
            Last Updated: August 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 md:py-12 px-4 md:px-6">
        <div className="glass max-w-4xl mx-auto px-8 md:px-12 py-12 md:py-16 space-y-12">
          {SECTIONS.map((section) => (
            <div key={section.title} className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold tracking-tighter uppercase text-zinc-900">
                {section.title}
              </h2>
              {section.body}
            </div>
          ))}
        </div>
      </section>
    </GlassPage>
  );
};

export default TermsOfService;
